import { useMemo, useCallback } from "react";
import { useAsync } from "react-async";
import axios from "axios";

const API_BASE = "/sv/api/SickReportLime";

const getUrl = endpoint => `${API_BASE}/${endpoint}`;

const deferPost = ([[url, data]]) =>
  axios({
    method: "post",
    url,
    data
  });

const getOnMount = ({ url, data }) =>
  axios({
    method: "get",
    url,
    data
  });

export const usePost = (endpoint, options = {}) => {
  const url = useMemo(() => getUrl(endpoint), [endpoint]);
  const { run, ...rest } = useAsync({ deferFn: deferPost, ...options });

  const post = useCallback(data => run([url, data]), [url, run]);

  return { post, ...rest };
};

export const useGetOnMount = (endpoint, options = {}) => {
  const url = useMemo(() => getUrl(endpoint), [endpoint]);
  
  const state = useAsync({ promiseFn: getOnMount, ...options, url });
  
  return state;
};
